var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195,23.8c-32,0-58.1,26-58.1,58.1v232.2c0,32,26,58.1,58.1,58.1h174.2c32,0,58.1-26,58.1-58.1v-182 c0-15.8-6.4-30.9-17.9-41.9L357,39.9c-10.8-10.3-25.2-16.1-40.2-16.1H195z M78.9,139.9c-32,0-58.1,26-58.1,58.1v232.2 c0,32,26,58.1,58.1,58.1H253c32,0,58.1-26,58.1-58.1v-14.5H253v14.5H78.9V197.9h14.5v-58.1H78.9z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Copy.812974374f5ecfc121087980cdb207fb.svg";